<template>
    <div style="margin-bottom: 3rem">
        <div style="height: 10px;margin: 0.3rem 0;display: flex;justify-content: space-between">
            <van-icon name="arrow-left" size="0.5rem" @click="before"/>
        </div>
        <div class="FGInfo-title">该装箱单涉及的相关订单</div>
        <table class="border-div"  border="0" cellspacing="0" cellpadding="0">
            <tr class="FG-tr">
                <td class="FG-tr-one">序号</td>
                <td class="FG-tr-two">订单号</td>
            </tr>
            <tr class="FG-tr" v-for="(i,index) in list.up" :key="index">
                <td class="FG-tr-one">{{index+1}}</td>
                <td class="FG-tr-two" @click="go_erpURL(i.order_number)">{{i.order_number}}</td>
            </tr>
        </table>
        <div class="FGInfo-title">该装箱单涉及的相关售后单</div>
        <table class="border-div" border="0" cellspacing="0" cellpadding="0">
            <tr class="FG-tr">
                <td class="FG-tr-one" >序号</td>
                <td class="FG-tr-two">订单号</td>
            </tr>
            <tr class="FG-tr" v-for="(i,s) in list.sh" :key="s">
                <td class="FG-tr-one">{{s+1}}</td>
                <td class="FG-tr-two" @click="go_erpURL(i.after_num)">{{i.after_num}}</td>
            </tr>
        </table>
        <div class="FGInfo-title">该客户近期未全部发货的相关订单</div>
        <table class="border-div"  border="0" cellspacing="0" cellpadding="0">
            <tr class="FG-tr">
                <td class="FG-tr-one" >序号</td>
                <td class="FG-tr-two">订单号</td>
            </tr>
            <tr class="FG-tr" v-for="(i,index) in list.down" :key="index">
                <td class="FG-tr-one">{{index+1}}</td>
                <td class="FG-tr-two" @click="go_erpURL(i.order_number)">{{i.order_number}}</td>
            </tr>
        </table>
    </div>
</template>

<script>
  export default {
    name: "FGlistInfo",
    data(){
      return{
        list:[]
      }
    },
    async mounted(){
      let packing = await this.get(this.APIOBJ.packingOrder,{id:this.$route.query.FGinfoID})
      this.list = packing.data.data
    },
    methods:{
      before(){
        this.$router.go(-1);
      },
      go_erpURL(id){
        let url = 'https://lcyjfz.cpolar.cn/public/question/54e58266-2b2d-4133-be7b-511341b107aa?order_number=' + id
        window.location.href = url
      }
    }
  }
</script>

<style lang="less">
*{
    font-size: 14px;
}
.FGInfo-title{
    width: 10rem;
    height: 0.5rem;
    margin: 0.5rem 0;
    text-align: left;
}
.FG-tr{
    width: 10rem;
}
.FG-tr-one{
    padding: 5px 10px;
    width: 4rem;
    text-align: left;
}
table td{
    border: 0.5px solid #333333;
}
.FG-tr-two{
    padding: 5px 10px;
    width: 6rem;
    text-align: left;
}
</style>